import { coerceBooleanProperty } from '@angular/cdk/coercion';

import {
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HippoLoadingService } from '@hippo/services/loading';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'hippo-loading-bar',
    templateUrl: './loading-bar.component.html',
    styleUrls: ['./loading-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'hippoLoadingBar',
    imports: [MatProgressBarModule],
})
export class HippoLoadingBarComponent implements OnChanges, OnInit, OnDestroy {
    @Input() autoMode: boolean = true;
    mode: 'determinate' | 'indeterminate';
    progress: number = 0;
    show: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(private _hippoLoadingService: HippoLoadingService) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On changes
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        // Auto mode
        if ('autoMode' in changes) {
            // Set the auto mode in the service
            this._hippoLoadingService.setAutoMode(
                coerceBooleanProperty(changes.autoMode.currentValue)
            );
        }
    }

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the service
        this._hippoLoadingService.mode$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.mode = value;
            });

        this._hippoLoadingService.progress$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.progress = value ?? 0;
            });

        this._hippoLoadingService.show$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                setTimeout(() => {
                    this.show = value;
                }, 1);
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
